import partnerClient from "../partnerClient";

export const fetchPartnerMe = async () => {
  const { data } = await partnerClient.get("/me");
  return data?.data ?? data;
};

export const updatePartnerMe = async (payload) => {
  const { data } = await partnerClient.put("/me", payload);
  return data?.data ?? data;
};

export const fetchPartnerTerms = async () => {
  const { data } = await partnerClient.get("/terms");
  return data?.data ?? data;
};

export const acceptPartnerTerms = async () => {
  const { data } = await partnerClient.post("/terms/accept");
  return data?.data ?? data;
};

export const uploadPartnerDocument = async (kind, file) => {
  const body = new FormData();
  body.append("file", file);
  const { data } = await partnerClient.post(`/me/documents?kind=${kind}`, body, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data?.data ?? data;
};
